import { HttpClient } from '@adapters/HttpClient';

export interface PaymentMethodOption {
  id: string;
  name: string;
}

export class PaymentMethodsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getAll(): Promise<PaymentMethodOption[]> {
    const raw = await this.httpClient.get<any>('/payment-methods');
    // Normalizamos por si acaso viene envuelto en { data: [...] }
    const list = Array.isArray(raw) ? raw : (raw.data ?? []);
    const result = list.map((m: any) => ({
      id: String(m.id),
      name: m.method,
    }));
    return result;
  }
}
